import { render, staticRenderFns } from "./ProductosModal.vue?vue&type=template&id=2a793e32&"
import script from "./ProductosModal.vue?vue&type=script&lang=js&"
export * from "./ProductosModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports